import { gql } from "@apollo/client";

const DELETE_STATUS = gql `
mutation deleteStatus($id:ID!){
    deleteStatus(id: $id){
        color
      key
      text
    }
}
`

const REFRESH_TOKEN = gql `
mutation RefreshToken($refreshToken:String!) {
  RefreshToken(refreshToken: $refreshToken) {
    authExpiration
    authToken
    refreshToken
  }
}

`
export { DELETE_STATUS, REFRESH_TOKEN }